<template>
  <div class="random-board-selector" v-bind:class="popoverDirectionClass" v-bind:disabled="disabled">
    <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" v-bind:disabled="disabled">
      Random
      <span class="caret"></span>
    </button>
    <div class="dropdown-menu">
      <div v-if="popoverDirectionClass === 'dropdown'" class="row hidden-xs" style="margin-bottom: -17px;">
        <div class="col-sm-4">
          <ul>
            <li v-on:click="setRandomFlop()">Random flop: <img height="32"> <img height="32"> <img height="32"></li>
          </ul>
        </div>
        <div class="col-sm-4">
          <ul>
            <li v-if="!disableTurnAndRiver" v-on:click="setRandomTurn()">Random turn: <img height="32"> <img height="32"> <img height="32"> <img height="32"></li>
          </ul>
        </div>
        <div class="col-sm-4">
          <ul>
            <li v-if="!disableTurnAndRiver" v-on:click="setRandomRiver()">Random river: <img height="32"> <img height="32"> <img height="32"> <img height="32"> <img height="32"></li>
          </ul>
        </div>
      </div>
      <hr v-if="popoverDirectionClass === 'dropdown'" class="hidden-xs">

      <div class="row hidden-xs">
        <div class="col-sm-4">
          <ul>
            <li class="dropdown-header">Rainbow (all different suits)</li>
            <li v-on:click="setRandomFlopAccordingToTexture('triple broadway', 'rainbow')">Triple broadway - eg. <img src="/static/cards/ace-of-spades.png"> <img src="/static/cards/queen-of-diamonds.png"> <img src="/static/cards/jack-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('double broadway', 'rainbow')">Double broadway - eg. <img src="/static/cards/king-of-spades.png"> <img src="/static/cards/ten-of-clubs.png"> <img src="/static/cards/four-of-diamonds.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('single broadway', 'rainbow')">Single broadway - eg. <img src="/static/cards/queen-of-hearts.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/three-of-spades.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('paired', 'rainbow')">Paired - eg. <img src="/static/cards/eight-of-spades.png"> <img src="/static/cards/five-of-diamonds.png"> <img src="/static/cards/five-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('raggedy', 'rainbow')">Raggedy - eg. <img src="/static/cards/nine-of-clubs.png"> <img src="/static/cards/four-of-diamonds.png"> <img src="/static/cards/two-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated middle', 'rainbow')">Coordinated middle - eg. <img src="/static/cards/nine-of-spades.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/six-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated small', 'rainbow')">Coordinated small - eg. <img src="/static/cards/four-of-spades.png"> <img src="/static/cards/three-of-clubs.png"> <img src="/static/cards/two-of-diamonds.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('bingo', 'rainbow')">Bingo - eg. <img src="/static/cards/ten-of-clubs.png"> <img src="/static/cards/ten-of-hearts.png"> <img src="/static/cards/ten-of-spades.png"></li>
            <li class="divider visible-xs"></li>
          </ul>
        </div>
        <div class="col-sm-4">
          <ul>
            <li class="dropdown-header">Two-toned (two of same suit)</li>
            <li v-on:click="setRandomFlopAccordingToTexture('triple broadway', 'two-toned')">Triple broadway - eg. <img src="/static/cards/ace-of-clubs.png"> <img src="/static/cards/queen-of-clubs.png"> <img src="/static/cards/jack-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('double broadway', 'two-toned')">Double broadway - eg. <img src="/static/cards/king-of-clubs.png"> <img src="/static/cards/ten-of-clubs.png"> <img src="/static/cards/four-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('single broadway', 'two-toned')">Single broadway - eg. <img src="/static/cards/queen-of-clubs.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/three-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('paired', 'two-toned')">Paired - eg. <img src="/static/cards/eight-of-clubs.png"> <img src="/static/cards/five-of-clubs.png"> <img src="/static/cards/five-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('raggedy', 'two-toned')">Raggedy - eg. <img src="/static/cards/nine-of-clubs.png"> <img src="/static/cards/four-of-clubs.png"> <img src="/static/cards/two-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated middle', 'two-toned')">Coordinated middle - eg. <img src="/static/cards/nine-of-clubs.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/six-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated small', 'two-toned')">Coordinated small - eg. <img src="/static/cards/four-of-clubs.png"> <img src="/static/cards/three-of-clubs.png"> <img src="/static/cards/two-of-hearts.png"></li>
            <li class="divider visible-xs"></li>
          </ul>
        </div>
        <div class="col-sm-4">
          <ul>
            <li class="dropdown-header">Monotone (all same suit)</li>
            <li v-on:click="setRandomFlopAccordingToTexture('triple broadway', 'monotone')">Triple broadway - eg. <img src="/static/cards/ace-of-clubs.png"> <img src="/static/cards/queen-of-clubs.png"> <img src="/static/cards/jack-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('double broadway', 'monotone')">Double broadway - eg. <img src="/static/cards/king-of-clubs.png"> <img src="/static/cards/ten-of-clubs.png"> <img src="/static/cards/four-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('single broadway', 'monotone')">Single broadway - eg. <img src="/static/cards/queen-of-clubs.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/three-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('raggedy', 'monotone')">Raggedy - eg. <img src="/static/cards/nine-of-clubs.png"> <img src="/static/cards/four-of-clubs.png"> <img src="/static/cards/two-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated middle', 'monotone')">Coordinated middle - eg. <img src="/static/cards/nine-of-clubs.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/six-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated small', 'monotone')">Coordinated small - eg. <img src="/static/cards/four-of-clubs.png"> <img src="/static/cards/three-of-clubs.png"> <img src="/static/cards/two-of-clubs.png"></li>
          </ul>
        </div>
      </div>

      <div v-if="popoverDirectionClass === 'dropdown'" class="row visible-xs">
        <div class="col-xs-12">
          <ul>
            <li v-on:click="setRandomFlop()">Random flop: <img height="32"> <img height="32"> <img height="32"></li>
            <li v-if="!disableTurnAndRiver" v-on:click="setRandomTurn()">Random turn: <img height="32"> <img height="32"> <img height="32"> <img height="32"></li>
            <li v-if="!disableTurnAndRiver" v-on:click="setRandomRiver()">Random river: <img height="32"> <img height="32"> <img height="32"> <img height="32"> <img height="32"></li>
            <li class="divider visible-xs"></li>
          </ul>
        </div>
      </div>
      <div class="row visible-xs">
        <div class="col-sm-4">
          <ul>
            <li class="dropdown-header">Monotone (all same suit)</li>
            <li v-on:click="setRandomFlopAccordingToTexture('triple broadway', 'monotone')">Triple broadway - eg. <img src="/static/cards/ace-of-clubs.png"> <img src="/static/cards/queen-of-clubs.png"> <img src="/static/cards/jack-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('double broadway', 'monotone')">Double broadway - eg. <img src="/static/cards/king-of-clubs.png"> <img src="/static/cards/ten-of-clubs.png"> <img src="/static/cards/four-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('single broadway', 'monotone')">Single broadway - eg. <img src="/static/cards/queen-of-clubs.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/three-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('raggedy', 'monotone')">Raggedy - eg. <img src="/static/cards/nine-of-clubs.png"> <img src="/static/cards/four-of-clubs.png"> <img src="/static/cards/two-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated middle', 'monotone')">Coordinated middle - eg. <img src="/static/cards/nine-of-clubs.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/six-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated small', 'monotone')">Coordinated small - eg. <img src="/static/cards/four-of-clubs.png"> <img src="/static/cards/three-of-clubs.png"> <img src="/static/cards/two-of-clubs.png"></li>
            <li class="divider visible-xs"></li>
          </ul>
        </div>
        <div class="col-sm-4">
          <ul>
            <li class="dropdown-header">Two-toned (two of same suit)</li>
            <li v-on:click="setRandomFlopAccordingToTexture('triple broadway', 'two-toned')">Triple broadway - eg. <img src="/static/cards/ace-of-clubs.png"> <img src="/static/cards/queen-of-clubs.png"> <img src="/static/cards/jack-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('double broadway', 'two-toned')">Double broadway - eg. <img src="/static/cards/king-of-clubs.png"> <img src="/static/cards/ten-of-clubs.png"> <img src="/static/cards/four-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('single broadway', 'two-toned')">Single broadway - eg. <img src="/static/cards/queen-of-clubs.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/three-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('paired', 'two-toned')">Paired - eg. <img src="/static/cards/eight-of-clubs.png"> <img src="/static/cards/five-of-clubs.png"> <img src="/static/cards/five-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('raggedy', 'two-toned')">Raggedy - eg. <img src="/static/cards/nine-of-clubs.png"> <img src="/static/cards/four-of-clubs.png"> <img src="/static/cards/two-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated middle', 'two-toned')">Coordinated middle - eg. <img src="/static/cards/nine-of-clubs.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/six-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated small', 'two-toned')">Coordinated small - eg. <img src="/static/cards/four-of-clubs.png"> <img src="/static/cards/three-of-clubs.png"> <img src="/static/cards/two-of-hearts.png"></li>
            <li class="divider visible-xs"></li>
          </ul>
        </div>
        <div class="col-sm-4">
          <ul>
            <li class="dropdown-header">Rainbow (all different suits)</li>
            <li v-on:click="setRandomFlopAccordingToTexture('triple broadway', 'rainbow')">Triple broadway - eg. <img src="/static/cards/ace-of-spades.png"> <img src="/static/cards/queen-of-diamonds.png"> <img src="/static/cards/jack-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('double broadway', 'rainbow')">Double broadway - eg. <img src="/static/cards/king-of-spades.png"> <img src="/static/cards/ten-of-clubs.png"> <img src="/static/cards/four-of-diamonds.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('single broadway', 'rainbow')">Single broadway - eg. <img src="/static/cards/queen-of-hearts.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/three-of-spades.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('paired', 'rainbow')">Paired - eg. <img src="/static/cards/eight-of-spades.png"> <img src="/static/cards/five-of-diamonds.png"> <img src="/static/cards/five-of-clubs.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('raggedy', 'rainbow')">Raggedy - eg. <img src="/static/cards/nine-of-clubs.png"> <img src="/static/cards/four-of-diamonds.png"> <img src="/static/cards/two-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated middle', 'rainbow')">Coordinated middle - eg. <img src="/static/cards/nine-of-spades.png"> <img src="/static/cards/seven-of-clubs.png"> <img src="/static/cards/six-of-hearts.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('coordinated small', 'rainbow')">Coordinated small - eg. <img src="/static/cards/four-of-spades.png"> <img src="/static/cards/three-of-clubs.png"> <img src="/static/cards/two-of-diamonds.png"></li>
            <li v-on:click="setRandomFlopAccordingToTexture('bingo', 'rainbow')">Bingo - eg. <img src="/static/cards/ten-of-clubs.png"> <img src="/static/cards/ten-of-hearts.png"> <img src="/static/cards/ten-of-spades.png"></li>
            <li class="divider visible-xs"></li>
          </ul>
        </div>
      </div>
      <div v-if="popoverDirectionClass === 'dropup'" class="row visible-xs">
        <div class="col-xs-12">
          <ul>
            <li v-on:click="setRandomFlop()">Random flop: <img height="32"> <img height="32"> <img height="32"></li>
            <li v-if="!disableTurnAndRiver" v-on:click="setRandomTurn()">Random turn: <img height="32"> <img height="32"> <img height="32"> <img height="32"></li>
            <li v-if="!disableTurnAndRiver" v-on:click="setRandomRiver()">Random river: <img height="32"> <img height="32"> <img height="32"> <img height="32"> <img height="32"></li>
          </ul>
        </div>
      </div>

      <hr v-if="popoverDirectionClass === 'dropup'" class="hidden-xs">
      <div v-if="popoverDirectionClass === 'dropup'" class="row hidden-xs">
        <div class="col-sm-4">
          <ul>
            <li v-on:click="setRandomFlop()">Random flop: <img height="32"> <img height="32"> <img height="32"></li>
          </ul>
        </div>
        <div class="col-sm-4">
          <ul>
            <li v-if="!disableTurnAndRiver" v-on:click="setRandomTurn()">Random turn: <img height="32"> <img height="32"> <img height="32"> <img height="32"></li>
          </ul>
        </div>
        <div class="col-sm-4">
          <ul>
            <li v-if="!disableTurnAndRiver" v-on:click="setRandomRiver()">Random river: <img height="32"> <img height="32"> <img height="32"> <img height="32"> <img height="32"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/services/utilities/utilities';
import flopInfoHelpers from '@/services/flop-info-helpers';
import constants from '@/services/constants';

export default {
  name: 'random-board-selector',
  props: ['presetHoleCards', 'popoverDirectionClass', 'disabled', 'disableTurnAndRiver'],
  methods: {
    setRandomFlop: function () {
      let boardCards;

      while (true) {
        boardCards = [];
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction);

        if (
          !this._checkIfTryingToUseAPresetHoleCard(boardCards, this.presetHoleCards) &&
          !utilities.general.checkForDuplicates(boardCards)
        ) {
          break;
        }
      }

      this.$emit('setBoard', boardCards);
    },
    setRandomTurn: function () {
      let boardCards;

      while (true) {
        boardCards = [];
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction);
        boardCards.push(this._getRandomCard());

        if (
          !this._checkIfTryingToUseAPresetHoleCard(boardCards, this.presetHoleCards) &&
          !utilities.general.checkForDuplicates(boardCards)
        ) {
          break;
        }
      }

      this.$emit('setBoard', boardCards);
    },
    setRandomRiver: function () {
      let boardCards;

      while (true) {
        boardCards = [];
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction);
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());

        if (
          !this._checkIfTryingToUseAPresetHoleCard(boardCards, this.presetHoleCards) &&
          !utilities.general.checkForDuplicates(boardCards)
        ) {
          break;
        }
      }

      this.$emit('setBoard', boardCards);
    },
    _getRandomCard: function () {
      let rank = constants.ranks[_.random(0, 12)];
      let suit = constants.suits[_.random(0, 3)];

      return rank + suit;
    },
    setRandomFlopAccordingToTexture: function (textureType, toneType) {
      let texture;
      let tone;
      let flopCards;

      while (true) {
        texture = flopInfoHelpers.getSampleTexture(textureType);
        tone = flopInfoHelpers.getSampleTone(toneType);
        flopCards = [
          texture[0] + tone[0],
          texture[1] + tone[1],
          texture[2] + tone[2],
        ];

        if (
          !this._checkIfTryingToUseAPresetHoleCard(flopCards, this.presetHoleCards) &&
          !utilities.general.checkForDuplicates(flopCards)
        ) {
          break;
        }
      }

      this.$emit('setBoard', flopCards);
    },
    _checkIfTryingToUseAPresetHoleCard: function (boardCards, presetHoleCards) {
      let tryingToUseAPresetHoleCard = false;

      boardCards.forEach(function (flopCard) {
        if (presetHoleCards.includes(flopCard)) {
          tryingToUseAPresetHoleCard = true;
        }
      });

      return tryingToUseAPresetHoleCard;
    },
  },
};
</script>

<style lang="scss" scoped>
  .random-board-selector {
    display: inline-block;
    vertical-align: top;

    .dropdown-menu {
      width: 860px;
    }

    ul {
      list-style: none;
      padding: 5px 0;
    }

    li:not(.dropdown-header):not(.divider) {
      cursor: pointer;
      padding: 10px 20px;

      &:hover {
        background: #F5F5F9;
      }
    }

    img {
      width: 2em;
    }

    .card-placeholder {
      width: 20px;
      height: 30px;
      border: 1px solid lightgray;
      display: inline;
    }

    .dropdown-toggle {
      height: 44px;
      width: 125px;
      font-size: 16px;
    }

    &[disabled] {
      pointer-events: none;
    }

    @media (max-width: 991px) {
      .dropdown-toggle {
        height: 72px;
        width: 175px;
        font-size: 16px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/controls/card-selection/random-board-selector.vue